import styled from 'vue3-styled-components';

// 모달 오버레이
export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

// 모달 컨텐츠
export const ModalContent = styled.div`
    background: white;
    border-radius: 12px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

// 모달 헤더
export const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e7eb;
    background-color: #f9fafb;
`;

// 모달 제목
export const ModalTitle = styled.h2`
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #111827;
`;

// 모달 닫기 버튼
export const ModalCloseButton = styled.button`
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    padding: 8px;
    border-radius: 6px;
    color: #6b7280;
    transition: all 0.2s;

    &:hover {
        background-color: #f3f4f6;
        color: #374151;
    }
`;

// 모달 바디
export const ModalBody = styled.div`
    padding: 24px;
    flex: 1;
    overflow-y: auto;
`;

// 모달 푸터
export const ModalFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid #e5e7eb;
    background-color: #f9fafb;
`;

// 파일 상세 컨테이너
export const FileDetailContainer = styled.div`
    width: 100%;
`;

// 파일 미리보기
export const FilePreview = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

// 이미지 컨테이너 - 중요: 이미지가 보이도록 수정
export const ImageContainer = styled.div`
    position: relative;
    width: 100%;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
    border-radius: 8px;
    overflow: hidden;
    border: 2px solid #e9ecef;
`;

// 이미지 미리보기 - 중요: 이미지가 제대로 표시되도록 수정
export const PreviewImage = styled.img`
    max-width: 100%;
    max-height: 600px;
    width: auto;
    height: auto;
    object-fit: contain;
    border-radius: 6px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: block; /* 중요: 이미지가 보이도록 */
    
    &.image-loading {
        opacity: 0.5;
    }
`;

// 이미지 로딩 상태
export const ImageLoading = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    color: #666;
    font-size: 14px;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

// 이미지 에러 상태
export const ImageError = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color: #fff5f5;
    border: 2px dashed #fed7d7;
    border-radius: 8px;
    color: #c53030;
    font-size: 14px;
    text-align: center;
    z-index: 10;
    
    small {
        margin-top: 8px;
        font-size: 11px;
        color: #999;
        word-break: break-all;
        max-width: 300px;
    }
`;

// PDF 컨테이너
export const PDFContainer = styled.div`
    width: 100%;
    height: 600px;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
`;

// PDF 뷰어
export const PDFViewer = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
`;

// PDF 로딩 상태
export const PDFLoading = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    background-color: #f5f5f5;
    border: 2px dashed #ddd;
    border-radius: 8px;
    color: #666;
    font-size: 14px;
`;

// PDF 에러 상태
export const PDFError = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    background-color: #fff5f5;
    border: 2px dashed #fed7d7;
    border-radius: 8px;
    color: #c53030;
    font-size: 14px;
`;

// 파일 정보
export const FileInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    background-color: #f8f9fa;
    border-radius: 8px;
    text-align: center;
    border: 2px solid #e9ecef;
`;

// 파일 아이콘
export const FileIcon = styled.div`
    font-size: 48px;
    margin-bottom: 16px;
`;

// 파일명
export const FileName = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 8px;
    word-break: break-all;
    max-width: 400px;
`;

// 파일 타입
export const FileType = styled.div`
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 16px;
`;

// 파일 크기
export const FileSize = styled.div`
    font-size: 12px;
    color: #666;
    margin-bottom: 8px;
`;

// 파일 업로드 날짜
export const FileUploadDate = styled.div`
    font-size: 12px;
    color: #666;
    margin-bottom: 16px;
`;

// 파일 URL (디버깅용)
export const FileUrl = styled.div`
    margin-top: 16px;
    padding: 8px 12px;
    background-color: #e9ecef;
    border-radius: 4px;
    font-size: 11px;
    color: #666;
    word-break: break-all;
    max-width: 400px;
    font-family: monospace;
    border: 1px solid #dee2e6;
`;

// 모달 버튼
export const ModalButton = styled.button`
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 8px;

    &.primary {
        background-color: #3b82f6;
        color: white;

        &:hover {
            background-color: #2563eb;
        }
    }

    &.secondary {
        background-color: #6b7280;
        color: white;

        &:hover {
            background-color: #4b5563;
        }
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;